module.exports = __webpack_public_path__ + "static/img/avater.c434b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/friends/avater.png
// module id = W7eB
// module chunks = 0